export default {
  // Header
  'nav.home': 'Главная',
  'nav.about': 'О нас',
  'nav.services': 'Услуги',
  'nav.products': 'Продукты',
  'nav.contact': 'Контакты',
  'header.getQuote': 'Получить цену',
  
  // Hero
  'hero.title': 'Премиальные запчасти для грузовиков и прицепов',
  'hero.subtitle': 'Ваш надежный партнер в поставке высококачественных запчастей для коммерческого транспорта. Быстрая доставка, конкурентные цены и экспертная поддержка.',
  'hero.shopNow': 'Купить сейчас',
  'hero.learnMore': 'Узнать больше',
  
  // About
  'about.title': 'О компании GB Group',
  'about.description': 'GB Group является ведущим поставщиком запчастей для грузовиков и прицепов с более чем 15-летним опытом работы в отрасли. Мы гордимся тем, что предоставляем высококачественную продукцию, конкурентные цены и исключительное обслуживание клиентов.',
  'about.experience': 'Лет опыта',
  'about.products': 'Доступных продуктов',
  'about.customers': 'Довольных клиентов',
  'about.countries': 'Обслуживаемых стран',
  'about.marketsServed': 'Обслуживаемых рынков',
  'about.supportAvailable': 'Поддержка доступна',
  'about.ourStory': 'Наша история',
  'about.storyP1': 'GB Group Truck\'s & Trailer\'s Spare Parts and Logistics была основана в 2004 году с простой миссией: предоставлять надежные высококачественные запчасти для растущей транспортной отрасли Туркменистана.',
  'about.storyP2': 'За последние 20 лет мы выросли из небольшого местного бизнеса в ведущего поставщика, обслуживающего 16 рынков по всему Туркменистану. Наши основные операции базируются в городе Ашхабад, где мы поддерживаем наш главный склад и логистический центр.',
  'about.storyP3': 'Мы специализируемся на предоставлении нашим клиентам надежных запчастей, которые поддерживают эффективную работу их автопарков. Наша приверженность качеству и обслуживанию клиентов сделала нас предпочтительным выбором для транспортных компаний по всему региону.',
  'about.contactUsToday': 'Свяжитесь с нами сегодня',
  'about.ourJourney': 'Наш путь',
  'about.journeySubtitle': 'Два десятилетия роста, инноваций и приверженности обслуживанию транспортной отрасли Туркменистана',
  'about.year2004': 'Основание компании',
  'about.year2004Desc': 'Начали наш путь в бизнесе запчастей для грузовиков и прицепов в Туркменистане',
  'about.year2008': 'Расширение рынка',
  'about.year2008Desc': 'Расширили операции для обслуживания нескольких регионов по всему Туркменистану',
  'about.year2015': 'Достигнуто 16 рынков',
  'about.year2015Desc': 'Успешно установили присутствие на 16 рынках по всему Туркменистану',
  'about.year2024': 'Ведущий поставщик',
  'about.year2024Desc': 'Стали надежным лидером в области надежных запчастей и логистических решений',
  'about.ourMission': 'Наша миссия',
  'about.missionDesc': 'Быть самым надежным поставщиком запчастей для грузовиков и прицепов в Туркменистане, предоставляя надежные продукты и исключительные логистические услуги, которые поддерживают бесперебойную работу автопарков наших клиентов.',
  'about.qualityAssurance': 'Гарантия качества',
  'about.qualityAssuranceDesc': 'Каждая запчасть соответствует самым высоким стандартам качества надежности и долговечности.',
  'about.fastLogistics': 'Быстрая логистика',
  'about.fastLogisticsDesc': 'Эффективная сеть доставки, охватывающая все 16 рынков по всему Туркменистану.',
  'about.expertSupport': 'Экспертная поддержка',
  'about.expertSupportDesc': 'Квалифицированная команда, предоставляющая техническую помощь и консультации по продуктам.',
  'about.ourLocations': 'Наши локации',
  'about.locationsSubtitle': 'Обслуживаем 16 рынков по всему Туркменистану с нашей главной штаб-квартирой в Ашхабаде',
  'about.mainHeadquarters': 'Главная штаб-квартира - Ашхабад',
  'about.phone': 'Телефон',
  'about.marketsWeServe': 'Рынки, которые мы обслуживаем',
  'about.marketsDesc': 'Мы с гордостью обслуживаем 16 рынков по всему Туркменистану, предоставляя надежные запчасти и логистические решения транспортным компаниям в каждом регионе. Наша обширная сеть обеспечивает быструю доставку и местную поддержку, где бы вы ни находились.',
  
  // Services
  'services.title': 'Наши услуги',
  'services.subtitle': 'Комплексные решения для всех ваших потребностей в грузовиках и прицепах',
  'services.wholesale': 'Оптовая торговля',
  'services.wholesaleDesc': 'Оптовые заказы с конкурентными ценами для дилеров и мастерских',
  'services.delivery': 'Быстрая доставка',
  'services.deliveryDesc': 'Быстрая и надежная доставка в ваше местоположение',
  'services.support': 'Техническая поддержка',
  'services.supportDesc': 'Экспертная помощь 24/7 в выборе и установке запчастей',
  'services.warranty': 'Гарантия качества',
  'services.warrantyDesc': 'Все продукты имеют гарантию производителя',
  'services.truckParts': 'Запчасти для грузовиков',
  'services.truckPartsDesc': 'Полный ассортимент оригинальных и неоригинальных запчастей для всех основных марок грузовиков, включая Mercedes-Benz, Volvo, Scania, MAN, DAF и Iveco.',
  'services.trailerParts': 'Запчасти для прицепов',
  'services.trailerPartsDesc': 'Полный выбор запчастей и аксессуаров для полуприцепов, платформ, цистерн и специализированных прицепов от ведущих производителей.',
  'services.customOrders': 'Индивидуальные заказы',
  'services.customOrdersDesc': 'Услуга специального заказа труднодоступных запчастей и оптовых заказов с конкурентными ценами для операторов автопарков и ремонтных мастерских.',
  'services.whatWeOffer': 'Что мы предлагаем',
  'services.whatWeOfferDesc': 'Полный спектр услуг, разработанных для поддержания бесперебойной работы ваших грузовиков и прицепов с минимальным временем простоя',
  'services.brandsWeSupport': 'Бренды, которые мы поддерживаем',
  'services.brandsDesc': 'Мы храним запчасти для всех основных производителей грузовиков и прицепов, обеспечивая совместимость и качество',
  'services.howItWorks': 'Как это работает',
  'services.howItWorksDesc': 'Простой и эффективный процесс получения необходимых запчастей быстро и без проблем',
  'services.whyChoose': 'Почему выбирают GB Group?',
  'services.whyChooseDesc': 'Ваш надежный партнер по запчастям для грузовиков и прицепов в Туркменистане',
  'services.yearsExp': '20+ лет',
  'services.yearsExpDesc': 'Опыт работы в индустрии автомобильных запчастей',
  'services.partsStock': '500K+',
  'services.partsStockDesc': 'Запчастей в наличии готовых к доставке',
  'services.satisfiedCustomers': '300K+',
  'services.satisfiedCustomersDesc': 'Довольных клиентов по всему Туркменистану',
  'services.support247': '24/7',
  'services.support247Desc': 'Поддержка клиентов доступна в любое время',
  'services.needParts': 'Нужны запчасти или есть вопросы?',
  'services.needPartsDesc': 'Наша команда готова помочь вам экспертными советами и быстрым обслуживанием. Свяжитесь с нами сегодня!',
  'services.contactUs': 'Свяжитесь с нами',
  'services.call': 'Позвонить +993 65049474',
  'services.feature1': 'Компоненты и детали двигателя',
  'services.feature2': 'Трансмиссионные системы',
  'services.feature3': 'Тормозные системы и компоненты',
  'services.feature4': 'Детали подвески',
  'services.feature5': 'Электрические компоненты',
  'services.feature6': 'Фильтры и элементы обслуживания',
  'services.feature7': 'Оси и системы подвески',
  'services.feature8': 'Опорные устройства и шкворни',
  'services.feature9': 'Тормозные камеры и регуляторы зазора',
  'services.feature10': 'Системы освещения и электрики',
  'services.feature11': 'Системы сцепления',
  'services.feature12': 'Детали кузова и аксессуары',
  'services.feature13': 'Услуга идентификации деталей',
  'services.feature14': 'Технические характеристики',
  'services.feature15': 'Руководство по установке',
  'services.feature16': 'Проверка совместимости',
  'services.feature17': 'Рекомендации по обслуживанию',
  'services.feature18': 'Поддержка устранения неполадок',
  'services.feature19': 'Доступна отправка в тот же день',
  'services.feature20': 'Варианты экспресс-доставки',
  'services.feature21': 'Безопасная упаковка',
  'services.feature22': 'Отслеживание заказа',
  'services.feature23': 'Местная и международная доставка',
  'services.feature24': 'Гибкие графики доставки',
  'services.feature25': 'Оригинальные запчасти OEM',
  'services.feature26': 'Сертифицированные неоригинальные бренды',
  'services.feature27': 'Процесс контроля качества',
  'services.feature28': 'Гарантийное покрытие',
  'services.feature29': 'Политика возврата и обмена',
  'services.feature30': 'Гарантия производительности',
  'services.feature31': 'Поиск редких деталей',
  'services.feature32': 'Скидки на оптовые заказы',
  'services.feature33': 'Решения для управления автопарком',
  'services.feature34': 'Индивидуальные цены',
  'services.feature35': 'Приоритетная обработка',
  'services.feature36': 'Выделенный менеджер аккаунта',
  'services.step1': 'Свяжитесь с нами',
  'services.step1Desc': 'Свяжитесь по телефону, электронной почте или посетите наш офис с вашими требованиями к запчастям или данными автомобиля.',
  'services.step2': 'Идентификация деталей',
  'services.step2Desc': 'Наши эксперты помогут определить точные детали, которые вам нужны, используя VIN-номера, коды деталей или спецификации автомобиля.',
  'services.step3': 'Цена и наличие',
  'services.step3Desc': 'Получите подробное предложение с ценами, наличием и предполагаемым временем доставки для необходимых вам деталей.',
  'services.step4': 'Подтверждение заказа',
  'services.step4Desc': 'Подтвердите свой заказ и произведите оплату через наши безопасные варианты оплаты, включая банковский перевод и наличные.',
  'services.step5': 'Доставка',
  'services.step5Desc': 'Ваши детали тщательно упакованы и отправлены с предоставлением информации для отслеживания для вашего удобства.',
  'services.step6': 'Послепродажная поддержка',
  'services.step6Desc': 'Наслаждайтесь нашей комплексной послепродажной поддержкой, включая руководство по установке и гарантийное покрытие.',
  
  // Products
  'products.title': 'Рекомендуемые продукты',
  'products.viewAll': 'Все продукты',
  'products.addToCart': 'В корзину',
  'products.inStock': 'В наличии',
  'products.new': 'Новинка',
  'products.sale': 'Скидка',
  'products.filters': 'Фильтры',
  'products.category': 'Категория',
  'products.allCategories': 'Все категории',
  'products.priceRange': 'Диапазон цен',
  'products.brand': 'Бренд',
  'products.availability': 'Наличие',
  'products.inStockOnly': 'Только в наличии',
  'products.sortBy': 'Сортировать',
  'products.featured': 'Рекомендуемые',
  'products.priceLowHigh': 'Цена: по возрастанию',
  'products.priceHighLow': 'Цена: по убыванию',
  'products.newest': 'Новинки',
  'products.pageTitle': 'Наши продукты',
  'products.pageSubtitle': 'Просмотрите наш обширный каталог премиальных запчастей для грузовиков и прицепов',
  'products.searchPlaceholder': 'Поиск запчастей...',
  'products.searchProducts': 'Поиск продуктов',
  'products.categories': 'Категории',
  'products.engineParts': 'Детали двигателя',
  'products.brakingSystem': 'Тормозная система',
  'products.suspension': 'Подвеска',
  'products.lighting': 'Освещение',
  'products.trailerParts': 'Детали прицепа',
  'products.productsFound': 'найдено продуктов',
  'products.nameAZ': 'Название А-Я',
  'products.highestRated': 'Высокий рейтинг',
  'products.outOfStock': 'Нет в наличии',
  'products.requestQuote': 'Запросить цену',
  'products.notifyMe': 'Уведомить меня',
  'products.reviews': 'отзывов',
  'products.noResults': 'Продукты не найдены',
  'products.noResultsDesc': 'Попробуйте изменить фильтры или условия поиска',
  'products.loadMore': 'Загрузить еще',
  'products.clearFilters': 'Очистить все фильтры',
  
  // Contact
  'contact.title': 'Свяжитесь с нами',
  'contact.subtitle': 'Свяжитесь с нашей командой для запросов и поддержки',
  'contact.name': 'Ваше имя',
  'contact.email': 'Электронная почта',
  'contact.phone': 'Номер телефона',
  'contact.message': 'Ваше сообщение',
  'contact.send': 'Отправить',
  'contact.info': 'Контактная информация',
  'contact.address': 'Адрес',
  'contact.addressValue': 'ул. Промышленная 123, Ашхабад, Туркменистан',
  'contact.phoneValue': '+993 12 345678',
  'contact.emailValue': 'info@gbgroup.tm',
  'contact.hours': 'Часы работы',
  'contact.hoursValue': 'Пн-Пт: 8:00 - 18:00',
  
  // Footer
  'footer.description': 'Ваш надежный партнер в поставке премиальных запчастей для грузовиков и прицепов.',
  'footer.quickLinks': 'Быстрые ссылки',
  'footer.categories': 'Категории',
  'footer.support': 'Поддержка',
  'footer.faq': 'Вопросы',
  'footer.shipping': 'Доставка',
  'footer.returns': 'Возврат',
  'footer.newsletter': 'Рассылка',
  'footer.newsletterDesc': 'Подпишитесь на специальные предложения и обновления',
  'footer.subscribe': 'Подписаться',
  'footer.rights': 'Все права защищены.',
  
  // Common
  'common.loading': 'Загрузка...',
  'common.error': 'Ошибка',
  'common.success': 'Успешно',
  'common.cancel': 'Отмена',
  'common.save': 'Сохранить',
  'common.delete': 'Удалить',
  'common.edit': 'Редактировать',
  'common.search': 'Поиск',
  'common.filter': 'Фильтр',
  'common.clear': 'Очистить',
  'common.apply': 'Применить',
  
  // Brands
  'brands.badge': 'Официальный дилер',
  'brands.title': 'Надежные бренды-партнеры',
  'brands.subtitle': 'Мы гордимся тем, что являемся официальным дилером всемирно известных брендов, гарантируя вам только оригинальные высококачественные запчасти.',
  'brands.guarantee': 'Все продукты поставляются с гарантией производителя и подтверждением подлинности',

  // Products page extra
  'products.gbGroupCatalogue': 'Каталог GB Group',
  'products.ownBrandBadge': 'Собственный бренд GB Group',
  'products.showcaseTitle1': 'Запчасти для грузовиков',
  'products.showcaseTitle2': 'Дисковые тормозные колодки',
  'products.showcaseDesc': 'Наша собственная линейка высокопроизводительных дисковых тормозных колодок, разработанных специально для европейских грузовиков. Соответствуют стандартам OEM для Mercedes-Benz, Volvo, Scania, MAN, DAF и Iveco.',
  'products.badgeOEM': 'Качество OEM',
  'products.badgeEuroTrucks': 'Европейские грузовики',
  'products.badgeLongLasting': 'Долговечные',
  'products.badgeInStock': 'В наличии',
  'products.fullCatalogue': 'Полный каталог',
  'products.browseAllParts': 'Просмотреть все запчасти',
  'products.cantFind': 'Не можете найти нужное?',
  'products.cantFindDesc': 'Наша команда может найти любую запчасть для грузовика или прицепа. Свяжитесь с нами, и мы найдем её для вас.',
  'products.requestCustomQuote': 'Запросить индивидуальное предложение',
  'products.handpickedSelection': 'Специальный выбор',
  'products.featuredProducts': 'Рекомендуемые продукты',
  'products.featuredBadge': 'Рекомендуемое',
  'products.genuineTagline': 'Оригинальные запчасти, надёжная работа',
  'products.cat.engine': 'Двигатель',
  'products.cat.braking': 'Тормоза',
  'products.cat.suspension': 'Подвеска',
  'products.cat.lighting': 'Освещение',
  'products.cat.trailer': 'Прицеп',
};